import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IVariacaoItem } from '../model/variacao.model';

@Injectable()
export class VariacaoItensService extends EntityService<IVariacaoItem> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'variacao_iten',
      urlBackend: configService.backendURL
    });
  }
}
